import PropTypes from "prop-types";

import { Chip, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { statusColors, statusLabels } from "@/features/purchase-invoices";
import { formatDate } from "@/features/shared";
import { UpstreamTransactionLink } from "@/features/ui";

export const GeneralInformationSection = ({ purchaseDownPayment }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          {purchaseDownPayment.status && (
            <Chip
              label={statusLabels[purchaseDownPayment.status]}
              color={statusColors[purchaseDownPayment.status]}
              size="small"
            />
          )}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {purchaseDownPayment.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(purchaseDownPayment.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pemasok
          </Typography>
          <Typography variant="body1">
            {purchaseDownPayment.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pembeli
          </Typography>
          <Typography variant="body1">
            {purchaseDownPayment.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Syarat Pembayaran
          </Typography>
          <Typography variant="body1">
            {purchaseDownPayment.paymentTerm?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pesanan Pembelian
          </Typography>
          <UpstreamTransactionLink
            referenceNumber={purchaseDownPayment.purchaseOrder?.referenceNumber}
            orderType={purchaseDownPayment.purchaseOrder?.orderType}
            shortReference={false}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">
            {purchaseDownPayment.note ?? "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  purchaseDownPayment: PropTypes.object.isRequired,
};
